/**
 * PilotageAlertsBanner — alertes pilotage (Lot 4) : sorties négatives de
 * mandats et chute des entrées. Affichées en haut du Cockpit Dirigeant,
 * ignorables individuellement (marquées lues).
 */
import React, { useCallback, useEffect, useState } from 'react';
import { AlertTriangle, TrendingDown, X } from 'lucide-react';
import api from '../../lib/api';

const STYLES = {
    pilotage_negative_exit: {
        icon: AlertTriangle, bg: 'rgba(220,38,38,0.08)',
        border: 'rgba(220,38,38,0.35)', color: '#dc2626',
    },
    pilotage_entries_drop: {
        icon: TrendingDown, bg: 'rgba(245,158,11,0.10)',
        border: 'rgba(245,158,11,0.40)', color: '#b45309',
    },
};

export default function PilotageAlertsBanner() {
    const [alerts, setAlerts] = useState([]);

    const load = useCallback(async () => {
        try {
            const r = await api.get('/pilotage/alerts');
            setAlerts(r.data.alerts || []);
        } catch (e) { /* silencieux */ }
    }, []);

    useEffect(() => { load(); }, [load]);

    const dismiss = async (id) => {
        setAlerts((a) => a.filter((x) => x.id !== id));
        try { await api.post(`/pilotage/alerts/${id}/dismiss`); } catch (e) { /* silencieux */ }
    };

    if (alerts.length === 0) return null;

    return (
        <div className="space-y-2" data-testid="pilotage-alerts-banner">
            {alerts.map((a) => {
                const s = STYLES[a.notification_type] || STYLES.pilotage_entries_drop;
                const Icon = s.icon;
                return (
                    <div key={a.id} data-testid={`pilotage-alert-${a.id}`}
                         className="flex items-start gap-3 rounded-xl border px-4 py-3"
                         style={{ background: s.bg, borderColor: s.border }}>
                        <Icon className="w-4 h-4 shrink-0 mt-0.5" style={{ color: s.color }} />
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-semibold" style={{ color: s.color }}>{a.title}</p>
                            <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>{a.message}</p>
                        </div>
                        <button type="button" onClick={() => dismiss(a.id)}
                                data-testid={`pilotage-alert-dismiss-${a.id}`}
                                aria-label="Ignorer l'alerte"
                                className="p-1 rounded-md hover:bg-black/5 shrink-0">
                            <X className="w-3.5 h-3.5" style={{ color: 'var(--muted-foreground)' }} />
                        </button>
                    </div>
                );
            })}
        </div>
    );
}
